import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import '../styles.css';

export default function LandingPage() {
  return (
    <main className="landing-page">
      <Helmet>
		  <title>HermesReads | Digital Library, EPUB Conversion, Metadata, and Publishing Services</title>
		  <meta
			name="description"
			content="HermesReads is a digital library, publishing project, and book-production service offering public-domain books, revived editions, EPUB conversion, metadata enrichment, ONIX preparation, and backlist recovery."
		  />
		  <meta
			name="keywords"
			content="HermesReads, digital library, EPUB conversion, ebook conversion, metadata services, ONIX metadata, book production services, public domain books, publishing services, backlist recovery, ebook formatting, print on demand preparation"
		  />
		  <meta property="og:title" content="HermesReads | Library, Publishing, EPUB Conversion, and Metadata Services" />
		  <meta
			property="og:description"
			content="A digital library, publishing project, and book-production service for public-domain books, revived editions, EPUB conversion, metadata work, and catalog cleanup."
		  />
		  <meta property="og:type" content="website" />
		  <meta property="og:url" content="https://www.hermesreads.com/" />
		  <meta property="og:image" content="https://www.hermesreads.com/android-chrome-512x512.png" />
		  <meta name="twitter:card" content="summary_large_image" />
		  <meta name="twitter:title" content="HermesReads | EPUB Conversion, Metadata, Publishing, and Digital Library" />
		  <meta
			name="twitter:description"
			content="HermesReads combines a public digital library with EPUB conversion, metadata enrichment, publishing support, and backlist recovery services."
		  />
		  <meta name="twitter:image" content="https://www.hermesreads.com/android-chrome-512x512.png" />
		  <link rel="canonical" href="https://www.hermesreads.com/" />

		  <script type="application/ld+json">
			{JSON.stringify({
			  "@context": "https://schema.org",
			  "@type": "Organization",
			  "name": "HermesReads",
			  "url": "https://www.hermesreads.com/",
			  "logo": "https://www.hermesreads.com/android-chrome-512x512.png",
			  "description": "HermesReads is a digital library, publishing project, and book-production service offering EPUB conversion, metadata enrichment, ONIX preparation, public-domain editions, and backlist recovery.",
			  "sameAs": []
			})}
		  </script>

		  <script type="application/ld+json">
			{JSON.stringify({
			  "@context": "https://schema.org",
			  "@type": "WebSite",
			  "name": "HermesReads",
			  "url": "https://www.hermesreads.com/",
			  "description": "Digital library, publishing project, EPUB conversion service, metadata service, and book-production platform.",
			  "potentialAction": {
				"@type": "SearchAction",
				"target": "https://www.hermesreads.com/search?query={search_term_string}",
				"query-input": "required name=search_term_string"
			  }
			})}
		  </script>

		  <script type="application/ld+json">
			{JSON.stringify({
			  "@context": "https://schema.org",
			  "@type": "Service",
			  "name": "EPUB conversion, metadata enrichment, and book-production services",
			  "provider": {
				"@type": "Organization",
				"name": "HermesReads",
				"url": "https://www.hermesreads.com/"
			  },
			  "areaServed": "Worldwide",
			  "serviceType": [
				"EPUB conversion",
				"ebook formatting",
				"metadata enrichment",
				"ONIX preparation",
				"backlist recovery",
				"public domain publishing preparation",
				"print-on-demand preparation"
			  ],
			  "url": "https://www.hermesreads.com/services"
			})}
		  </script>
		</Helmet>

      <section className="landing-hero">
        <p className="landing-kicker">HermesReads</p>

        <h1>A library, publishing project, and book-production service.</h1>

        <p className="landing-lead">
          HermesReads brings together public-domain books, revived editions, EPUB conversion,
          metadata work, and publishing support for older, neglected, and difficult-to-process texts.
        </p>
      </section>

      <section className="landing-paths" aria-label="HermesReads sections">
        <Link to="/library" className="landing-card landing-card-library">
          <span className="landing-card-label">Library</span>
          <h2>Explore the Library</h2>
          <p>
            Browse and read public-domain books across philosophy, literature, history, religion,
            politics, science, mythology, and more.
          </p>
          <strong>Enter the library</strong>
        </Link>

        <Link to="/services" className="landing-card landing-card-services">
          <span className="landing-card-label">Services</span>
          <h2>Book Production Services</h2>
          <p>
            EPUB conversion, metadata repair, backlist recovery, ONIX preparation, distributor
            upload cleanup, and large-catalog workflows.
          </p>
          <strong>View services</strong>
        </Link>

        <Link to="/publishing" className="landing-card landing-card-publishing">
          <span className="landing-card-label">Publishing</span>
          <h2>HermesReads Publishing</h2>
          <p>
            Editions, translations, public-domain revivals, and selected works prepared for modern
            digital and print distribution.
          </p>
          <strong>See publishing project</strong>
        </Link>
      </section>
    </main>
  );
}